import { render, staticRenderFns } from "./Block4.vue?vue&type=template&id=4beb9f37&scoped=true"
import script from "./Block4.vue?vue&type=script&lang=js"
export * from "./Block4.vue?vue&type=script&lang=js"
import style0 from "./Block4.vue?vue&type=style&index=0&id=4beb9f37&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb9f37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4beb9f37')) {
      api.createRecord('4beb9f37', component.options)
    } else {
      api.reload('4beb9f37', component.options)
    }
    module.hot.accept("./Block4.vue?vue&type=template&id=4beb9f37&scoped=true", function () {
      api.rerender('4beb9f37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block4.vue"
export default component.exports